import { render } from "./PatientDataBD.vue?vue&type=template&id=3f589b86&scoped=true"
import script from "./PatientDataBD.vue?vue&type=script&lang=js"
export * from "./PatientDataBD.vue?vue&type=script&lang=js"

import "./PatientDataBD.vue?vue&type=style&index=0&id=3f589b86&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3141391227/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f589b86"]])

export default __exports__